import { render, staticRenderFns } from "./Step_Thanks.vue?vue&type=template&id=aede7938&scoped=true&"
import script from "./Step_Thanks.vue?vue&type=script&lang=js&"
export * from "./Step_Thanks.vue?vue&type=script&lang=js&"
import style0 from "./Step_Thanks.vue?vue&type=style&index=0&id=aede7938&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aede7938",
  null
  
)

export default component.exports